<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="typeName" label="服务类型名称"></el-table-column>
      <el-table-column fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            @click="add(scope.row)"
            type="primary"
            size="small"
            v-if="!scope.row.parentId"
          >新增下一级</el-button>
          <el-button type="success" @click="compile(scope.row)" v-if="scope.row.type!=-1" size="small">编辑</el-button>
          <el-button type="danger" @click="remove(scope.row)" v-if="scope.row.type!=-1" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--  -->
    <el-dialog :title="title" :visible.sync="visible" width="30%" :modal="false" >
      <div>
        <el-form ref="form" :model="form" label-width="120px"  :rules="rules">
          <el-form-item label="服务类型名称" prop="typeName">
            <el-input v-model="form.typeName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllChildrenPolicyClassifyData,
  oldManOrganizationServeTypeList,
  oldManOrganizationServeTypeEdit,
  oldManOrganizationServeTypeDelete
} from "../api/index.js";
export default {
  data() {
    return {
      data: [
        
      ],
      tableData: [
        
      ],
      form: {},
      type: "",
      row: {},
      visible: false,
      title: "",
      rules: {
        typeName: [{ required: true, message: "请输入服务类型名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    //拿到树
    oldManOrganizationServeTypeListAPI(e) {
      oldManOrganizationServeTypeList(e).then(res => {
        let arr = [
          {
            typeName:'服务类型主树',
            id:0,
            type:-1,
            children:[]
          }
        ]
          arr[0].children = res.content
          this.tableData =arr
      });
    },
    //新增
    add(row) {
       this.form = {}
      this.row = row;
      this.title = '新增'
      this.visible = true;
      this.type = "add";
      // oldManOrganizationServeTypeEdit().then(res => {
      //   this.$message({
      //     type: "success",
      //     message: "新增成功!"
      //   });
      // });
    },
    //编辑
    compile(row) {
      this.visible = true;
      this.title = '编辑'
      this.type = "compile";
      this.row = row;
      this.$set(this.form, "typeName", row.typeName);
      // oldManOrganizationServeTypeEdit().then(res => {
      //   this.$message({
      //     type: "success",
      //     message: "编辑成功!"
      //   });
      // });
    },
    //删除
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          oldManOrganizationServeTypeDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.oldManOrganizationServeTypeListAPI({});
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //弹出框
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //根据type判断是新增还是编辑
          if (this.type == "add") {
            let params = {
              parentId: this.row.id,
              typeName: this.form.typeName,
            };
            
            oldManOrganizationServeTypeEdit(params).then(res => {
              this.$message({
                type: "success",
                message: "新增成功!"
              });
              this.visible = false;
              this.oldManOrganizationServeTypeListAPI({});
            });
          } else if (this.type == "compile") {
            let params = {
              parentId: this.row.parentId,
              id: this.row.id,
              typeName: this.form.typeName
            };
            oldManOrganizationServeTypeEdit(params).then(res => {
              this.$message({
                type: "success",
                message: "编辑成功!"
              });
              this.visible = false;
              this.oldManOrganizationServeTypeListAPI({});
            });
          }
        }
      });
    }
  },
  created() {
    this.oldManOrganizationServeTypeListAPI({
      
    });
  }
};
</script>
<style scoped>
.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}
.slot {
  height: 500px;
  overflow: auto;
}
.el-form-item {
  margin-bottom: 20px !important;
}
</style>>